import React from 'react';
import {
  selectIsProductSearching,
  selectProducts,
} from '~redux/search/product';
import {
  productEquals,
  useProductSearchSelector,
} from '~view/widgets/ProductSearchProvider';
import ProductSlider from '~view/widgets/ProductSlider';

const Items: React.FC<{ listId: string }> = ({ listId }) => {
  const products = useProductSearchSelector(
    selectProducts,
    listId,
    productEquals
  );
  const isSearching = useProductSearchSelector(
    selectIsProductSearching,
    listId
  );

  return (
    <ProductSlider
      isLoading={isSearching}
      products={products}
      title="新着アイテム"
    />
  );
};

export default Items;
